import { API_BASE_URL } from "../config";

/** `credits` is present only when the account is metered in credits and the source cost some. */
export type UsageEntry = {
  count: number;
  credits?: number;
};

export type UsageBucket = {
  start: string;
  sources: Record<string, UsageEntry>;
  total: UsageEntry;
};

export type UsageResponse = {
  granularity: string;
  start: string;
  end: string;
  buckets: UsageBucket[];
  sources: Record<string, UsageEntry>;
  total: UsageEntry;
};

export const fetchUsage = async (
  accessToken: string,
  start?: string,
  end?: string,
): Promise<UsageResponse> => {
  const params = new URLSearchParams();
  if (start) params.set("start", start);
  if (end) params.set("end", end);

  const qs = params.toString();
  const url = `${API_BASE_URL}/api/v1/usage${qs ? `?${qs}` : ""}`;

  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!res.ok) {
    throw new Error(`Usage API error: ${res.status}`);
  }

  return res.json();
};
